import * as React from 'react';
import { Col, Flex } from 'Common/components/Atoms/Flex';
import { BubbleIcon } from 'Common/components/Molecules/BubbleIcon';
import {
  faDollarSign,
  faLaptopCode,
  faCalendarAlt,
  faUsers,
} from '@fortawesome/pro-solid-svg-icons';
import { Text } from 'Common/components/Atoms/Text';
import { styled } from '@mui/material';
import { LANDING } from 'DisplayText/ReviewerOnboarding';

const Section = styled(Col)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.grey[300],
  padding: theme.spacing(6),
}));

const Title = styled(Text)(({ theme }) => ({
  '&&&&': {
    fontSize: 36,
    marginBottom: 16,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('lg')]: {
      marginBottom: 32,
    },
  },
}));

const ReasonContainer = styled(Flex)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  width: 974,
  [theme.breakpoints.down('md')]: {
    width: 800,
  },
}));

const Reason = styled(Flex)(({ theme }) => ({
  padding: 30,
  width: 420,
  minWidth: 420,
  [theme.breakpoints.down('md')]: {
    padding: 0,
    marginBottom: 50,
    width: 450,
  },
}));

const ReasonTitle = styled(Text)(({ theme }) => ({
  '&&&&': {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },
}));

const Description = styled(Text)(({ theme }) => ({
  '&&&&': {
    fontSize: 16,
    width: 340,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('md')]: {
      fontSize: 18,
      width: '100%',
    },
  },
}));

export const Justification = () => {
  return (
    <Section>
      <Title>{LANDING.WHY_REVIEW}</Title>
      <ReasonContainer>
        <Reason>
          <BubbleIcon icon={faDollarSign} size="2x" p={4} py={3} />
          <Col ml={2}>
            <ReasonTitle variant="h2">{LANDING.MONEY_TITLE}</ReasonTitle>
            <Description>{LANDING.MONEY_DESCRIPTION}</Description>
          </Col>
        </Reason>
        <Reason>
          <BubbleIcon icon={faLaptopCode} size="2x" p={3} />
          <Col ml={2}>
            <ReasonTitle variant="h2">{LANDING.QUALITY_TITLE}</ReasonTitle>
            <Description>{LANDING.QUALITY_DESCRIPTION}</Description>
          </Col>
        </Reason>
        <Reason>
          <BubbleIcon icon={faCalendarAlt} size="2x" p={3.5} py={3} />
          <Col ml={2}>
            <ReasonTitle variant="h2">{LANDING.FLEXIBLE_TITLE}</ReasonTitle>
            <Description>{LANDING.FLEXIBLE_DESCRIPTION}</Description>
          </Col>
        </Reason>
        <Reason>
          <BubbleIcon icon={faUsers} size="2x" p={3} />
          <Col ml={2}>
            <ReasonTitle variant="h2">{LANDING.COMMUNITY_TITLE}</ReasonTitle>
            <Description>{LANDING.COMMUNITY_DESCRIPTION}</Description>
          </Col>
        </Reason>
      </ReasonContainer>
    </Section>
  );
};
